import React from 'react';
import { ChessboardDnDProvider } from 'react-chess-core';

export const ChessboardTouchDnDProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => <ChessboardDnDProvider>{children}</ChessboardDnDProvider>;
